import { InvoiceStateTypes, InvoiceActionTypes } from "./Invoice.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: InvoiceStateTypes = {
  fetchAll: resetApiCallState([]),
};

const InvoiceReducer = (
  state: InvoiceStateTypes = INITIAL_STATE,
  action: any
): InvoiceStateTypes => {
  switch (action.type) {
    case InvoiceActionTypes.FETCH_ALL_INVOICE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case InvoiceActionTypes.FETCH_ALL_INVOICE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case InvoiceActionTypes.FETCH_ALL_INVOICE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case InvoiceActionTypes.FETCH_ALL_INVOICE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default InvoiceReducer;
